import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRouteSnapshot, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ItemContextService } from '../../helper/itemContext/item-context.service';
import { Item } from '../../interfaces/item';
import { TranslatesService } from '../../helper/translate/translate.service';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.css']
})
export class BreadcrumbsComponent implements OnInit {
  public item!: Item;
  public breadcrumb: string | undefined;

  constructor(
    private router: Router,
    private itemContext: ItemContextService,
    public _translateService: TranslatesService,
  ) {}

  ngOnInit(): void {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      const deepest = this.findDeepestRoute(this.router.routerState.snapshot.root);
      this.breadcrumb = deepest.data['breadcrumb'];
    });

    this.itemContext.item$.subscribe(item => {
      this.item = item;
    });
  }

  private findDeepestRoute(route: ActivatedRouteSnapshot): ActivatedRouteSnapshot {
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route;
  }
}
